import { render, staticRenderFns } from "./ProductsSelector.vue?vue&type=template&id=365a3d5e&"
import script from "./ProductsSelector.vue?vue&type=script&lang=js&"
export * from "./ProductsSelector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("Q:\\Projects\\marketingdatabase-git\\MarketingDb.Web.Zeiss\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('365a3d5e')) {
      api.createRecord('365a3d5e', component.options)
    } else {
      api.reload('365a3d5e', component.options)
    }
    module.hot.accept("./ProductsSelector.vue?vue&type=template&id=365a3d5e&", function () {
      api.rerender('365a3d5e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "ScriptsV2/Core/Modules/JourneyBuilder/Components/Charts/SankeyV2/ProductsSelector.vue"
export default component.exports